<template>
    <div class="ts-border ts-p-3 ts-rounded">
        <div class="row">
            <div class="col-md-6 ts-space-y-3">
                <div class="row">
                    <label class="required form-col-label control-label col-md-3">{{
                        $t('purchaseRequestTemplate.templateName') }}</label>
                    <div class="col-md-9">
                        <input v-model="model.template_name" type="text" class="form-control" :class="{
                            'is-invalid': errors.has('template_name')
                        }" :placeholder="$t('purchaseRequestTemplate.templateName')" />
                        <div class="validate" v-if="errors.has('template_name')">
                            {{ errors.first('template_name') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 ts-space-y-3">
                <div class="row">
                    <label class="form-col-label control-label col-md-3">{{
                        $t('purchaseRequestTemplate.templateDescription') }}</label>
                    <div class="col-md-9">
                        <textarea v-model="model.template_description" rows="3" class="form-control"
                            :placeholder="$t('purchaseRequestTemplate.templateDescription')"></textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
    name: 'templateInfo',
    props: ['value', 'validate'],
    data() {
        return {
            errors: new Errors(),
            model: {}
        }
    },
    created() {
        this.model = this.value
    },
    watch: {
        validate: function (error) {
            this.errors = new Errors(error.errors)
        }
    }
}
</script>
